import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Header } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class UnauthorisedFeature extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  render() {
    const { title, copy } = this.props;

    return (
      <Fragment>
        <Header as="h3">{title}</Header>
        <p>{copy("unauthorised_feature.body")}</p>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(UnauthorisedFeature);
